import React from 'react'


const Fetching = () => {
    const loaderCenter = {
        height: '100vh'
    };
    return (
        <>
            <div style={loaderCenter} className='d-flex align-items-center justify-content-center'>
                <div>
                    <div className="spinner-border ms-2" role="status">
                    </div>
                </div>
            </div>
        </>
    )
}

export default Fetching
